<template>
    <div class="auth-wrapper auth-v2">
        <div class="w-100 d-flex flex-column justify-content-between">
            <div class="px-2">
                <HeaderBar/>
                    <div
                    class="d-flex flex-column mb-2 mt-4"
                    style="font-size: 15px; font-weight: 500"
                    >
                        <div class="add-economic-record-title1 mt-2 text-center">
                            Cargar datos Inseminación
                        </div>
                    </div>
                    <validation-observer ref="GanForm">
                        <b-form class="auth-register-form mt-2" @submit.prevent="validationForm">
                            <b-form-group label="Fecha" 
                            label-for="fecha_compra">
                                <validationProvider
                                #default="{ errors }"
                                name="Fecha"
                                rules="required"
                                >
                                    <b-form-datepicker id="fecha_compra" name="fecha_compra" v-model="reproductive.date" 
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    :min="minCfgDate" :max="maxCfgDate"
                                    locale="es-ES"/>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validationProvider>
                            </b-form-group>
                            <b-form-group label="Seleccionar Vaca(Hembras)" >
                                <b-form-select  id="selFemale" v-model="animal_picker" :options="animalsOptions" :values="animalsOptions.value" label="text"  />
                            </b-form-group>
                            <b-form-group label="Identificación de la pajilla" label-for="condition"  class="condition" >
                                <b-form-checkbox v-model="strawExist">Usar Pajilla Existente</b-form-checkbox>
                                <b-form-input  v-if="!strawExist" v-model="reproductive.insemination" @focus="strawCreator" />
                                <b-form-select  v-if="strawExist" v-model="reproductive.insemination":options="malesOptions"
                                :values="malesOptions.value" />
                            </b-form-group>
                            <b-form-group  label="Observaciones" label-for="Exam">
                                <validation-provider #default="{ errors }" name="Exam" vid="Exam" rules="required">
                                    <b-form-textarea id="textarea" ref="observations" v-model="reproductive.details"  rows="5"
                                        max-rows="6"></b-form-textarea>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group  label="Inseminado por" label-for="Exam">
                                <validation-provider #default="{ errors }" name="Exam" vid="Exam" rules="required">
                                    <b-form-input  v-model="reproductive.by"/>
                                </validation-provider>
                            </b-form-group>
                        </b-form>
                        <b-modal size="sm" centered v-model="modalShow" hide-footer hide-header>
                            <div>
                                <div class="d-flex justify-content-center mt-1 mb-2 text-justify">
                                    <h3>Identificación de pajilla</h3>
                                </div>
                                <b-form-group  label="Registro de animal" label-for="Exam">
                                    <validation-provider
                                    #default="{ errors }"
                                    name="Código"
                                    rules="required"
                                    >
                                        <b-form-input id="sirigapp" v-model="straw.code"/>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group  label="Nombre" label-for="Exam">
                                    <validation-provider
                                    #default="{ errors }"
                                    name="Nombre"
                                    rules="required"
                                    >
                                        <b-form-input id="sirigapp" v-model="straw.name"/>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group  label="Raza" label-for="Exam">
                                    <validation-provider
                                    #default="{ errors }"
                                    name="Raza"
                                    rules="required"
                                    >
                                        <b-form-input id="sirigapp" v-model="straw.race"/>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group> 
                                <div class="d-flex justify-content-center mt-1 mb-2 text-justify">
                                    <b-button @click="strawGeneartor" class="bg-primary w-75 mt-2 " block>
                                    Aceptar
                                    </b-button>
                                </div>
                            </div>
                        </b-modal> 
                    </validation-observer>
                    <div class="additive">
                        <b-button
                            type="submit" v-on:click="insertReproductive"
                            class="bg-primary dataButton mt-3 d-flex align-items-center justify-content-center ml-3"   
                        >
                            <div class="ml-5 mr-5"> Incluir Evento </div>
                        </b-button>
                    </div>
                <ControlMenu />
            </div>
        </div>
    </div>
</template>



<script>
import HeaderBar from '@/components/HeaderBar.vue'
import ControlMenu from '@/components/ControlMenu.vue'
import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BCol, BFormGroup, BFormInput, BForm, BFormDatepicker,BFormSelect, BImg, BButton, BFormTextarea, BFormCheckbox } from 'bootstrap-vue'
import { required } from '@validations'
import flatPickr from 'vue-flatpickr-component'

let self= this;

export default {
    components: {
        HeaderBar,
        ControlMenu,
        flatPickr,
        BFormGroup,
        ValidationProvider,
        ValidationObserver,
        BFormGroup,
        BFormInput,
        BForm,
        BFormCheckbox,
        BFormDatepicker,
        BFormSelect,
        required,
        vSelect,
        BImg,
        BButton,
        BFormTextarea,
    },
    data() {
        
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        // 15th two months prior
        const minDate = new Date(today)
        minDate.setMonth(minDate.getMonth() - 119)
        minDate.setDate(15)
        // 15th in two months
        const maxDate = new Date(today)
        maxDate.setMonth
        maxDate.setMonth(maxDate.getMonth())
        maxDate.setDate(maxDate.getDate())
        return {
            malesOptions:[],
            strawExist:false,
            modalShow:false,
            maxCfgDate:maxDate,
            minCfgDate:minDate,
            date: today,
            animal_picker: null,
            animalsOptions:[],
            reproductive:{
                farm_id: localStorage.getItem('currentFarm'),
                status:1,
                date:today,
                condition_id:1,
                type:8,
                animal_id:0,
                days:0,
                male_id:0,
                details:null,
                insemination:null
            },
            straw:{
                farm_id:localStorage.getItem('currentFarm'),
                code:null,
                name:null,
                race:null
            }
        }
    },
    methods:{
        async fetchStraws(config){
            let farmId= localStorage.getItem('currentFarm');
            let self=this;
            fetch(this.$apiUrl+"list/straws?recperpage=all&farm_id="+farmId, config)
            .then(response => response.json())
            .then(result => {
                console.log(result.straws);
                result.straws.forEach(function(item){
                console.log('Cargando pajillas');
                if(item.farm_id==farmId){
                    self.malesOptions.push({value:item.id,text:'Pajilla: '+item.code+' '+item.name});
                }
                
                });
            })
            },
        async fetchAnimals(config){
            let farmId= localStorage.getItem('currentFarm');
            fetch(this.$apiUrl+"list/animals?farm_id="+farmId+"&sex=1&pregnant=0&state=1", config)
            .then(response => response.json())
            .then(result => {
                console.log(result.animals);
                this.animalsOptions = result.animals.map(item => {return {value:item.id,text:item.number+ ' '+item.name}})
            })
        },

        insertReproductive(){
            this.reproductive.animal_id=this.animal_picker;
            this.reproductive.male_id=this.reproductive.animal_id;
            const token = localStorage.getItem("accessToken");
            const config = {headers: {"X-Authorization": `Bearer ${token}`}};
            console.log(this.reproductive);
            this.$refs.GanForm.validate().then(success => { 
                if(success){
                    this.$http.post("add/reproductive_records", this.reproductive, config).then((result) => {
                        console.log(result);
                        this.reproductive={
                            status:1,
                            date:null,
                            condition_id:1,
                            type:8,
                            animal_id:0,
                            days:0,
                            male_id:0,
                            details:'',
                            insemination:''
                        }
                    
                        this.$swal({
                            title: 'Registro reproductivo',
                            text: 'Se insertó registro de inseminación de manera satisfactoria',
                            type: 'success',
                            icon:'success',
                            showCancelButton: false,
                            confirmButtonColor:'#5E8F23',
                            showCloseButton: true,
                            showLoaderOnConfirm: false  
                        }).then(function(){
                            history.back();
                        });
                    }).catch(error => {
                        console.log(error)
                    });
                }
            })
        },
        strawCreator(){
            this.$refs.observations.focus();
            this.modalShow=true;
        },
        strawGeneartor(){
            const token = localStorage.getItem("accessToken");
            const config = {headers: {"X-Authorization": `Bearer ${token}`}};
            let date= new Date();
            let mYear= date.getFullYear();
            let mMonth= date.getMonth();
            this.reproductive.insemination=mYear+''+mMonth+this.straw.code;
            this.$http.post('add/straws',this.straw,config);
            this.modalShow=false;
            /*this.$refs.GanForm.validate().then(success => { 
                if(success){
                    
                }
                
            });*/
            
        }
    },
    created() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchAnimals(config);
        this.fetchStraws(config);
    }
}
</script>
    

<style lang="scss">
.dataUploadTitle {
    position: absolute;
    top: 7%;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #5E5873;
}

@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/pages/page-auth.scss';
</style>